import React, { Component } from 'react';
import { NavLink }          from 'react-router-dom';
import BookdocLogo          from 'assets/logos/Sidebar.svg';
import { SidebarLinks }     from './SidebarLinks';
import PhoneIcon            from 'assets/icons/Phone-white.png';
import EmailIcon            from 'assets/icons/Email-white.png';

export class DesktopSidebar extends Component {
  render() {
    return (
      <div id="desktop-sidebar" className="d-lg-block d-none ">
        <div className="bg-white p-10">
          <NavLink end={ true } to="/eb" className="h-100" >
            <img src={ BookdocLogo } alt="bookdoc-logo" className="w-100"/>
          </NavLink>
        </div>

        <div id="desktop-sidebar-links" className="pt-6 bg-grey">
          <div className="link-containers">
            <SidebarLinks />
          </div>

          <div className="contact-us-info text-white p-6 font-size-4">
            <b>Contact Us</b><br/>
            <img src={ PhoneIcon } className="w-em-3 mr-2" alt="contact-phone" />1300 88 2362<br/>
            <img src={ EmailIcon } className="w-em-3 mr-2" alt="contact-email" />care@bookdoc.com
          </div>
        </div>
      </div>
    );
  }
}